import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/look-up/extra-reducers';
import reducers from 'src/redux/look-up/reducers';
import { lookUpInitialState } from './types';

const lookUpSlice = createSlice({
  name: 'lookUp',
  initialState: lookUpInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const { updateLookupData, marketsLookUpStarted, marketsLookUpFailed } = lookUpSlice.actions;

export default lookUpSlice.reducer;
